const parseIntOr0 = (inputString, radix = 10) => {
  const parsed = parseInt(inputString, radix);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const getAudience = ({ publicCount, participantCount }) =>
  parseIntOr0(publicCount) + parseIntOr0(participantCount);


export default getAudience;



// WEBPACK FOOTER //
// ./src/helpers/controlHelpers.js